import {api, endpoints} from '@/api'

const state = {
  placesLoading: false,
  places: [],
}

const getters = {
  placesLoading: state => state.placesLoading,
  places: state => state.places,
}

const actions = {
  fetchPlaces: async function ({commit, getters}) {
    commit("placesLoading", {loading: true})
    if (getters.selectedTenant === null) {
      return
    }
    try {
      const r = await api(endpoints.fetch_place(), {tenant: getters.selectedTenant}, {method: 'GET'})
      if (r.ok) {
        const names = (await r.json()).map(i => i.place)
        commit("places",  {places: names})
      } else {
        // TODO: error handling
      }
    } catch (err) {
      console.error(err)
    } finally {
      commit("placesLoading", {loading: false})
    }
  }
}

const mutations = {
  placesLoading (state, {loading}) {
    state.placesLoading = loading
  },
  places (state, {places}) {
    state.places = places
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
